module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Roadmap-to-Ivy-Leagues_Cover-7564f82be8dddebdef4ebb5935afda0a.jpg";